
/* eslint no-useless-escape: 0 */
var formHelper = (function () {
  function validateEmail (email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(email)
  }

  return {
    validateEmail:        validateEmail
  }
})()

export default formHelper



// WEBPACK FOOTER //
// ./src/helpers/formHelper.js